// Implements: F-UIX-014, F-UIX-015
/**
 * The catch-all. An address that matches nothing is not an error to report,
 * it is a screen with a way back (the redesign's centred state).
 *
 * It also answers the platform guard, an unknown id and a foreign one, so it
 * says nothing about WHY the address shows nothing (checklist 4).
 */

import type { ReactElement } from "react";

import { useTranslation } from "../../shared/i18n";
import { StatePage } from "./StatePage";

export function NotFoundPage(): ReactElement {
  const { t } = useTranslation();
  return (
    <StatePage
      icon="search"
      title={t("app.notFound.title")}
      body={t("app.notFound.body")}
      backLabel={t("app.notFound.back")}
    />
  );
}
